import Vue from "vue";

import livechat from "./livechat.service"
import playerService from "./player.service"

export default {
  async login(data) {
    let loginResult = (await Vue.http.post("/api/v2/authentication/login", data)).data;
    if (loginResult.isSuccess) {
      livechat.set(loginResult.player, 'Login');
    }
    return loginResult;
  },
  async pinLogin(pincode) {
    return (await Vue.http.post("/api/v2/authentication/login/pin", { pincode })).data;
  },
  async fastlogin(loginKey) {
    return (await Vue.http.post(`/api/v2/authentication/fastlogin/${loginKey}`)).data;
  },
  async logout() {
    try {
      await Vue.http.get("/api/v2/authentication/logout");
    } catch (err) {
      console.error(err);
    }
    livechat.set(await playerService.getAnonymous(), 'Logout');
  },
  async resetTemporaryPassword(newPassword) {
    return (await Vue.http.post("/api/v2/authentication/password/temporary/reset", { newPassword })).data;
  },
  async changePassword(oldPassword, newPassword) {
    return (await Vue.http.post("/api/v2/authentication/password/reset", { oldPassword, newPassword })).data;
  },  
  async restorePassword(data, recaptchaResponse) {
    return (await Vue.http.post("/api/v2/authentication/password/restore", { data, recaptchaResponse })).data;
  },
  async isLoginUnique(username) {
    return (await Vue.http.post("/api/v2/authentication/login/check", { username })).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/authentication.service.js